define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_card/validate_request_form",

        validation: {
            address_country_cd: {
                required: true
            },
            address_province: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            address_city: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            address_rest: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            address_zip: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            passport_no:{
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            name_on_card:{
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            phone_country: {
                required: true
            },
            phone_area: {
                required: true
            },
            phone_rest: {
                required: true
            },
            email: {
                required: true,
                pattern: 'email'
            },
            signature_img:{
                required: true
            },
            ple:{
                required: true
            },
            identification:{
                required: true
            },
            poa:{
                required: true
            },
            agree1:{
                acceptance: true
            },
            agree2:{
                acceptance: true
            },
            agree3:{
                acceptance: true
            },
            agree4:{
                acceptance: true
            }
        }
    });
});
